import React from 'react';
import { Text } from '@tamagui/core';
import { XStack, YStack } from '@tamagui/stacks';
import { COLORS } from '@/constants/colors';
import { BADGE_BORDER_RADIUS } from './constants';

type InfoBadgeProps = {
  icon: React.ReactNode;
  text: string;
};

const InfoBadge: React.FC<InfoBadgeProps> = ({ icon, text }) => {
  return (
    <YStack borderRadius={BADGE_BORDER_RADIUS} overflow="hidden">
      <YStack backgroundColor={COLORS.WHITE_90}>
        <XStack paddingHorizontal="$3" paddingVertical="$2" alignItems="center" gap="$2">
          {icon}
          <Text color={COLORS.ZINC_900}>{text}</Text>
        </XStack>
      </YStack>
    </YStack>
  );
};

export default InfoBadge;
